import { minMaxRangeZodSchema } from "@@/utilities/set-within-range";
import { z } from "zod";
import { accommodationRateIdFactory } from "./accommodation-rate-id";

const rateConditionGuestOccupancyZodObject = z.object({
    _id: z.string(),
    _type: z.literal("RATE_CONDITION"),
    type: z.enum(["GUEST_OCCUPANCY"]),

    value: minMaxRangeZodSchema,
});

type AccommodationRateGuestConditions = z.infer<
    typeof rateConditionGuestOccupancyZodObject
>;

// Accommodation Rate Factory
const _accommodationRateFactoryParamsZodObject =
    rateConditionGuestOccupancyZodObject.omit({
        _id: true,
        _type: true,
    });
type AccommodationRateConditionsFactoryParams = z.infer<
    typeof _accommodationRateFactoryParamsZodObject
>;
const accommodationGuestConditionFactory = (
    params: AccommodationRateConditionsFactoryParams,
) => {
    const accommodationRate: AccommodationRateGuestConditions = {
        ...params,
        _id: accommodationRateIdFactory(),
        _type: "RATE_CONDITION",
    };
    return accommodationRate;
};

const rateConditionStayZodObject = z.object({
    _id: z.string(),
    _type: z.literal("RATE_CONDITION"),
    type: z.enum(["STAY"]),

    value: minMaxRangeZodSchema,
});

type AccommodationRateStayConditions = z.infer<
    typeof rateConditionStayZodObject
>;

const _accommodationStayFactoryParamsZodObject =
    rateConditionStayZodObject.omit({
        _id: true,
        _type: true,
    });
type AccommodationRateConditionsFactoryParams2 = z.infer<
    typeof _accommodationStayFactoryParamsZodObject
>;

const accommodationStayConditionFactory = (
    params: AccommodationRateConditionsFactoryParams2,
) => {
    const accommodationRate: AccommodationRateStayConditions = {
        ...params,
        _id: accommodationRateIdFactory(),
        _type: "RATE_CONDITION",
        type: "STAY",
    };
    return accommodationRate;
};

const accommodationConditionDuplicateFactory = (
    current: AccommodationRateStayConditions | AccommodationRateGuestConditions,
) => {
    const accommodationRate:
        | AccommodationRateStayConditions
        | AccommodationRateGuestConditions = {
        ...current,
        _id: accommodationRateIdFactory(),
    };
    return accommodationRate;
};

const rateConditionZodObject = z.union([
    rateConditionGuestOccupancyZodObject,
    rateConditionStayZodObject,
]);

export {
    accommodationConditionDuplicateFactory,
    accommodationGuestConditionFactory,
    accommodationStayConditionFactory,
    rateConditionGuestOccupancyZodObject,
    rateConditionZodObject,
};
export type {
    AccommodationRateConditionsFactoryParams,
    AccommodationRateGuestConditions,
    AccommodationRateStayConditions,
};
